module.exports = __webpack_public_path__ + "img/resized-APP-0008-1.026ddfea.png";